<template>
  <div class="duplicated">
    <div class="page-header">
      <h3 class="page-title">중복된 가입 정보</h3>
    </div>
    <div class="container">
      <div class="page-inner">
        <h1 class="step-title">
          이미 가입 된 <br />
          회원 정보가 있습니다.
        </h1>
        <p class="step-sub-title">
          아래의 휴대폰 번호가 맞으신가요?<br />
          <b>{{ userData.cell }}</b>
        </p>

        <div class="bottom-btn">
          <p class="mt-10">
            가입한 휴대폰 번호가 다르거나 가입한 적이 없는 경우 고객센터 1577-4644로
            문의 주세요
          </p>
          <v-btn color="primary" x-large depressed block rounded class="mb-3" @click="goTo">로그인</v-btn>
          <KakaoButton @kakaoSignUp="$emit('kakaoSignUp', $event)" @kakaoSignIn="$emit('kakaoSignIn', $event)" />

        </div>
      </div>
    </div>

  </div>
</template>

<script>
import KakaoButton from "@/_bayer/kakaoCommon/KakaoButton.vue";
export default {
  components: { KakaoButton },
  props: {
    userData: {
      type: Object,
    },
  },
  methods: {
    goTo() {
      this.$router.push({ path: "/login" }).catch(() => { });
    },
  },
};
</script>

<style lang="scss">
.duplicated {
  padding: 0;
  height: 100vh;
  overflow: hidden;

  .page-inner {
    text-align: center;
    position: relative;
    height: calc(100svh - 92px);
    padding: 1rem 0 0;
    margin: 0 auto 1rem;
  }

  .step-title {
    margin-top: 40px;
    font-size: 32px;

  }

  .step-sub-title {
    font-size: 16px;
    font-weight: 700;
    color: #646464;
    margin-top: 40px;

    b {
      color: #000000;
      font-size: 24px;
      font-weight: 500;
    }



  }


  .bottom-btn {
    position: absolute;
    width: 100%;
    bottom: 0;

    p {
      font-size: 16px;
      color: #646464;
      margin-top: 40px;
    }
  }

  .v-btn.btn-kakao {
    background: #f6d523;
    color: #000000;
  }
}
</style>